export const aiWidgetInfos = {
    // Achievement & Stats Widgets
    achievementsBanner: {
        aiDescription: "Ein kraftvolles Achievements-Banner Widget mit Titel und 3 Erfolgs-Metriken. Jede Metrik zeigt eine große Zahl, Beschreibungstext, vertikale Linie und Icon. Unterstützt Hintergrundbild und Vordergrund-Bild in der linken unteren Ecke. Perfekt für Social Proof, Statistiken und Erfolgs-Darstellung.",
        aiDesignTags: ["achievements", "statistics", "social-proof", "success-metrics", "numbers", "background-image", "professional", "trust-building", "credibility", "milestone-showcase"]
    },

    spiritualQuoteCard: {
        aiDescription: "Ein inspirierendes spirituelles Quote-Card Widget mit Hintergrundbild und elegantem weißem Container. Enthält ein Icon, Titel, dekoratives Symbol und Rich Text Content. Perfekt für spirituelle Quotes, Weisheiten, Mantras und inspirierende Botschaften mit starker visueller Wirkung.",
        aiDesignTags: ["spiritual", "inspiration", "quotes", "wisdom", "mantras", "meditation", "mindfulness", "healing", "transformation", "background-image", "elegant-design", "rich-text", "spiritual-symbols"]
    },

    // Gallery Widgets
    galleryWidget: {
        aiDescription: "Ein elegantes Gallery-Widget mit Titel, Beschreibung und Masonry Grid Layout. Zeigt Bilder in einem responsiven, Pinterest-artigen Raster mit Hover-Effekten und Lightbox-Funktionalität. Perfekt für Portfolios, Projekte, Produkt-Galerien und visuelle Präsentationen.",
        aiDesignTags: ["gallery", "portfolio", "masonry-grid", "visual-showcase", "responsive", "lightbox", "hover-effects", "image-grid", "projects", "photography", "creative", "visual-content"]
    },

    // Product Widgets
    productInfoWidget: {
        aiDescription: "Ein umfassendes Widget zur Präsentation digitaler Produkte wie E-Books, Online-Kurse und Templates. Zeigt Produktbilder, Preise, Features und Call-to-Action Buttons. Unterstützt verschiedene Layout-Modi (card, hero, inline) und dynamische Produktverbindungen. Ideal für E-Commerce und digitale Produktverkäufe.",
        aiDesignTags: ["e-commerce", "product-showcase", "digital-products", "pricing", "features", "call-to-action", "responsive", "card-layout", "hero-section", "sales-focused"]
    },

    heroHeader: {
        aiDescription: "Ein Premium Hero-Section Widget für professionelle Landing-Pages. Kombiniert Hero-Bilder, Logos, mehrstufige Text-Hierarchie und prominente Call-to-Action Buttons. Perfekt für Homepages, Produktlaunches und Marketing-Kampagnen mit starker visueller Wirkung.",
        aiDesignTags: ["hero-section", "landing-page", "marketing", "branding", "call-to-action", "premium-design", "logo-integration", "background-image", "responsive", "conversion-focused"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                titleText: { maxLength: 50, type: 'headline', priority: 'high', prompt: 'Kraftvoller Haupttitel der sofort Aufmerksamkeit erregt und das Wertversprechen kommuniziert' },
                subtitleText: { maxLength: 80, type: 'subtitle', priority: 'high', prompt: 'Überzeugender Untertitel der das Angebot präzisiert und Neugier weckt' },
                descriptionText: { maxLength: 200, type: 'description', priority: 'medium', prompt: '2-3 Sätze über die Hauptvorteile, Transformation oder Lösung die angeboten wird' },
                additionalText: { maxLength: 150, type: 'additional', priority: 'low', prompt: 'Zusätzliche Details oder unterstützende Information' },
                buttonText: { maxLength: 20, type: 'cta', priority: 'high', prompt: 'Action-orientierter Button-Text der zur gewünschten Handlung auffordert' }
            },
            
            design: {
                colors: ['titleColor', 'subtitleColor', 'descriptionColor', 'buttonBackground', 'backgroundColor'],
                layout: ['layoutType'], // classic-split, minimal-center, image-left, image-right
                typography: ['titleSize', 'titleWeight', 'titleFont', 'subtitleFont'],
                effects: ['titleEffect', 'subtitleEffect', 'enableAnimations', 'animationType'],
                spacing: ['padding', 'marginTop', 'marginBottom']
            },
            
            assets: {
                heroImage: { type: 'background', priority: 'high', fallback: 'industry-default' },
                logoImage: { type: 'brand', priority: 'medium', fallback: 'none' }
            }
        },
        
        // LAYOUT-OPTIONEN für AI-Entscheidung
        aiLayoutOptions: {
            'classic-split': 'Text links, Bild rechts - klassisch und vertrauenswürdig',
            'minimal-center': 'Zentriert, minimalistisch - modern und clean',
            'image-left': 'Bild links, Text rechts - visuell fokussiert',
            'image-right': 'Text links, Bild rechts - content-fokussiert'
        },
        
        // BRANCHEN-SPEZIFISCHE ANPASSUNGEN
        industryOptimization: {
            spiritual: { layoutType: 'minimal-center', animationType: 'fadeInSlow', titleEffect: 'gradient' },
            wellness: { layoutType: 'classic-split', animationType: 'fadeInUp', titleEffect: 'glow' },
            business: { layoutType: 'classic-split', animationType: 'slideIn', titleEffect: 'none' },
            ecommerce: { layoutType: 'image-right', animationType: 'fadeInUp', titleEffect: 'shadow' }
        }
    },

    hiWidget: {
        aiDescription: "Ein persönliches Vorstellungs-Widget mit organischen Bildformen und individueller Gestaltung. Ideal für Personal Branding, About-Seiten und persönliche Vorstellungen. Unterstützt verschiedene Bildformen, custom Fonts und responsive Design für authentische Selbstpräsentation.",
        aiDesignTags: ["personal-branding", "introduction", "about-section", "profile-image", "organic-shapes", "personal-story", "authentic", "custom-fonts", "responsive", "individual"]
    },

    videoTeaser: {
        aiDescription: "Ein hochwertiges Video-Widget mit YouTube-Integration, Rich-Text-Unterstützung und Header-Bildern. Kombiniert Videoinhalte mit beschreibenden Texten und Call-to-Actions. Perfekt für Produktdemos, Testimonials und Content-Marketing mit Video-Fokus.",
        aiDesignTags: ["video-content", "youtube-integration", "content-marketing", "rich-text", "multimedia", "engagement", "demo", "testimonial", "header-image", "call-to-action"]
    },

    simplicisticHeader: {
        aiDescription: "Ein minimalistisches Header-Widget mit Background-Effekten und cleaner Typografie. Fokussiert auf Einfachheit und Eleganz mit Background-Opacity-Kontrolle, Text-Schatten und Icon-Support. Ideal für moderne, minimalistische Designs und Clean-Layout-Ansätze.",
        aiDesignTags: ["minimalist", "clean-design", "modern", "background-effects", "typography", "elegant", "simple", "text-shadow", "icon-support", "contemporary"]
    },

    supremeTestimonial: {
        aiDescription: "Ein Premium-Testimonial-Widget mit Carousel-Funktionalität, Background-Bildern und Avatar-Support. Zeigt mehrere Kundenbewertungen in einem eleganten, professionellen Layout. Perfekt für Social Proof, Vertrauensaufbau und Glaubwürdigkeit auf Business-Websites.",
        aiDesignTags: ["testimonials", "social-proof", "customer-reviews", "trust-building", "carousel", "avatar-images", "premium-design", "credibility", "business", "professional"]
    },

    simplicisticQuote: {
        aiDescription: "Ein vielseitiges Content-Widget für Zitate, Rich-Text und inspirational Content. Unterstützt Background-Bilder, Text-Alignment und Rich-Text-Formatierung. Ideal für Blogs, inspirational Websites und Content-fokussierte Seiten mit emotionaler Wirkung.",
        aiDesignTags: ["quotes", "rich-text", "inspirational", "content-focused", "blog", "emotional", "text-alignment", "background-image", "typography", "storytelling"]
    },

    methodologyWidget: {
        aiDescription: "Ein strukturiertes Prozess-Widget zur Darstellung von Schritt-für-Schritt-Methoden und Workflows. Zeigt nummerierte Schritte, Profilbilder und detaillierte Beschreibungen in einem dunklen, professionellen Theme. Perfekt für Coaching, Consulting und Service-Erklärungen.",
        aiDesignTags: ["process-explanation", "step-by-step", "methodology", "coaching", "consulting", "workflow", "numbered-steps", "professional", "dark-theme", "service-description"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                mainTitle: { maxLength: 40, type: 'main-title', priority: 'high', prompt: 'Haupttitel der die Methodik oder den Prozess beschreibt' },
                mainDescription: { maxLength: 180, type: 'main-description', priority: 'high', prompt: 'Beschreibung der Methodik und ihrer Vorteile' },
                step1Number: { maxLength: 5, type: 'step-number', priority: 'high', prompt: 'Schritt-Nummer (z.B. 01, 1, Step 1)' },
                step1Title: { maxLength: 35, type: 'step-title', priority: 'high', prompt: 'Titel des ersten Schritts' },
                step1Description: { maxLength: 140, type: 'step-description', priority: 'high', prompt: 'Detaillierte Beschreibung des ersten Schritts' },
                step2Number: { maxLength: 5, type: 'step-number', priority: 'high', prompt: 'Schritt-Nummer für Schritt 2' },
                step2Title: { maxLength: 35, type: 'step-title', priority: 'high', prompt: 'Titel des zweiten Schritts' },
                step2Description: { maxLength: 140, type: 'step-description', priority: 'high', prompt: 'Detaillierte Beschreibung des zweiten Schritts' },
                step3Number: { maxLength: 5, type: 'step-number', priority: 'high', prompt: 'Schritt-Nummer für Schritt 3' },
                step3Title: { maxLength: 35, type: 'step-title', priority: 'high', prompt: 'Titel des dritten Schritts' },
                step3Description: { maxLength: 140, type: 'step-description', priority: 'high', prompt: 'Detaillierte Beschreibung des dritten Schritts' }
            },
            
            design: {
                colors: ['backgroundColor', 'mainTitleColor', 'mainDescriptionColor', 'stepTitleColor', 'stepDescriptionColor'],
                layout: ['layoutType'], // classic-methodology, image-top-centered, steps-only, creative-bottom
                typography: ['mainTitleSize', 'mainTitleFont', 'stepTitleSize', 'stepTitleFont'],
                effects: ['mainTitleEffect', 'stepTitleEffect', 'enableAnimations', 'animationType'],
                spacing: ['padding', 'stepSpacing', 'marginTop', 'marginBottom']
            },
            
            assets: {
                profileImage: { type: 'profile', priority: 'medium', fallback: 'methodology-default' }
            }
        },
        
        aiLayoutOptions: {
            'classic-methodology': 'Text links, Bild rechts, horizontale Steps - klassisch und strukturiert',
            'image-top-centered': 'Bild oben zentriert, Steps horizontal - visuell fokussiert',
            'steps-only': 'Nur Steps ohne Bild - content-fokussiert und kompakt',
            'creative-bottom': 'Bild unten, Steps oben - kreativ und unkonventionell'
        },
        
        industryOptimization: {
            coaching: { layoutType: 'classic-methodology', animationType: 'fadeInUp', mainTitleEffect: 'gradient' },
            consulting: { layoutType: 'steps-only', animationType: 'slideIn', mainTitleEffect: 'shadow' },
            spiritual: { layoutType: 'image-top-centered', animationType: 'fadeInSlow', mainTitleEffect: 'glow' }
        }
    },

    personalBrandingWidget: {
        aiDescription: "Ein umfassendes Personal-Branding-Widget mit Image-Overlays, dynamischen Bullet-Points und professionellen Layouts. Kombiniert Profilbilder mit strukturierten Informationen und Call-to-Actions. Ideal für Coaches, Berater und Experten zur Selbstpräsentation.",
        aiDesignTags: ["personal-branding", "professional-bio", "expertise", "coaching", "consulting", "image-overlay", "bullet-points", "expert-positioning", "credibility", "authority"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                overlayName: { maxLength: 25, type: 'name', priority: 'high', prompt: 'Persönlicher Name oder Begrüßung (z.B. "Hi, I\'m Sarah")' },
                overlayTitle1: { maxLength: 30, type: 'title', priority: 'high', prompt: 'Erste Titel-Zeile der Expertise oder Position' },
                overlayTitle2: { maxLength: 30, type: 'title', priority: 'medium', prompt: 'Zweite Titel-Zeile für weitere Qualifikation' },
                overlayTitle3: { maxLength: 30, type: 'title', priority: 'low', prompt: 'Dritte Titel-Zeile für zusätzliche Expertise' },
                mainQuestion: { maxLength: 60, type: 'question', priority: 'high', prompt: 'Hauptfrage die das Problem der Zielgruppe anspricht' },
                helpText: { maxLength: 120, type: 'help-text', priority: 'medium', prompt: 'Beschreibung wie geholfen wird oder was angeboten wird' },
                'bulletPoints.0.text': { maxLength: 40, type: 'bullet-point', priority: 'high', prompt: 'Erster Qualifikations- oder Vorteilspunkt' },
                'bulletPoints.1.text': { maxLength: 40, type: 'bullet-point', priority: 'high', prompt: 'Zweiter Qualifikations- oder Vorteilspunkt' },
                'bulletPoints.2.text': { maxLength: 40, type: 'bullet-point', priority: 'high', prompt: 'Dritter Qualifikations- oder Vorteilspunkt' },
                buttonText: { maxLength: 20, type: 'cta', priority: 'high', prompt: 'Call-to-Action Button-Text' }
            },
            
            design: {
                colors: ['backgroundColor', 'overlayTitleColor', 'mainQuestionColor', 'bulletPointColor', 'buttonBackground'],
                layout: ['containerLayout'], // glass-card, minimal-overlay, creative-split
                typography: ['overlayTitleFont', 'mainQuestionFont', 'bulletPointFont'],
                effects: ['overlayTitleEffect', 'enableAnimations', 'animationType'],
                spacing: ['padding', 'overlayPadding', 'bulletSpacing'],
                bullets: ['bulletPointStyle'] // elegant, modern, luxury, minimal, default
            },
            
            assets: {
                profileImage: { type: 'profile-hero', priority: 'high', fallback: 'personal-branding-default' }
            }
        },
        
        aiLayoutOptions: {
            'glass-card': 'Glasmorphism-Overlay über Bild - modern und elegant',
            'minimal-overlay': 'Minimales Text-Overlay - clean und fokussiert',
            'creative-split': 'Kreative Aufteilung - künstlerisch und einzigartig'
        },
        
        aiBulletStyles: {
            'elegant': 'Runde Icons mit Akzentfarbe - elegant und professionell',
            'modern': 'Blaue Linie links - modern und strukturiert',
            'luxury': 'Gradient-Icons - luxuriös und hochwertig',
            'minimal': 'Kleine Punkte - minimalistisch und clean',
            'default': 'Standard-Bullets - klassisch und vertraut'
        },
        
        industryOptimization: {
            coaching: { containerLayout: 'glass-card', bulletPointStyle: 'elegant', animationType: 'fadeInUp' },
            consulting: { containerLayout: 'minimal-overlay', bulletPointStyle: 'modern', animationType: 'slideIn' },
            spiritual: { containerLayout: 'creative-split', bulletPointStyle: 'luxury', animationType: 'fadeInSlow' }
        }
    },


    simplisticTestimonial: {
        aiDescription: "Ein elegantes Testimonial-Widget mit Card-basiertem Layout und Bild-Support. Zeigt Kundenbewertungen in einem clean, modernen Design mit responsiver Gestaltung. Ideal für Service-Websites, E-Commerce und Vertrauensaufbau mit authentischen Bewertungen.",
        aiDesignTags: ["testimonials", "customer-reviews", "card-layout", "clean-design", "modern", "responsive", "trust-building", "authentic", "service-focused", "e-commerce"]
    },

    eventInfoWidget: {
        aiDescription: "Ein umfassendes Event-Widget zur Präsentation von Live-Events, Webinaren und Workshops. Zeigt Event-Details, Termine, Zeitpläne, Ticket-Optionen und Standorte in verschiedenen Layout-Modi. Unterstützt sowohl digitale als auch physische Events mit Timeline-Ansicht, Ticket-Karten und dynamischer Event-Verbindung. Perfekt für Event-Marketing und Ticketverkauf.",
        aiDesignTags: ["events", "live-events", "webinars", "workshops", "event-marketing", "ticket-sales", "timeline-view", "event-schedule", "location-display", "digital-events", "in-person-events", "event-promotion", "registration", "event-details"]
    },

    courseInfoWidget: {
        aiDescription: "Ein spezialisiertes Course-Widget zur Präsentation von Online-Kursen, Masterclasses und Video-Trainings. Zeigt Kurs-Module, Lektionen, Lernmaterialien und Fortschritts-Indikatoren in verschiedenen Layout-Modi. Unterstützt Video-Module mit Beschreibungen, Dauer-Angaben und herunterladbare Ressourcen. Perfekt für E-Learning-Plattformen und Kurs-Marketing.",
        aiDesignTags: ["online-courses", "e-learning", "video-training", "masterclass", "course-modules", "learning-materials", "progress-tracking", "educational-content", "course-marketing", "skill-development", "certification", "video-lessons", "downloadable-resources", "learning-platform"]
    },

    infiniteBanner: {
        aiDescription: "Ein dynamisches Banner-Widget mit endlos scrollenden Feature-Points im Marquee-Style. Zeigt Verkaufs-Argumente, Garantien und Benefits in einem auffälligen, animierten Banner. Perfekt für Marketing-Kampagnen, Angebots-Promotion und Eye-Catching-Elemente.",
        aiDesignTags: ["marquee-banner", "infinite-scroll", "marketing", "promotion", "feature-highlights", "sales-arguments", "animated", "eye-catching", "benefits", "guarantees"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                'featurePoints.0.text': { maxLength: 25, type: 'banner-feature', priority: 'high', prompt: 'Kurzer, prägnanter Feature-Text der einen Hauptvorteil kommuniziert' },
                'featurePoints.1.text': { maxLength: 25, type: 'banner-feature', priority: 'high', prompt: 'Kurzer, prägnanter Feature-Text der einen Hauptvorteil kommuniziert' },
                'featurePoints.2.text': { maxLength: 25, type: 'banner-feature', priority: 'high', prompt: 'Kurzer, prägnanter Feature-Text der einen Hauptvorteil kommuniziert' },
                'featurePoints.3.text': { maxLength: 25, type: 'banner-feature', priority: 'high', prompt: 'Kurzer, prägnanter Feature-Text der einen Hauptvorteil kommuniziert' }
            },
            
            design: {
                presets: ['stylePreset'], // Nutzt bestehende 16 Style-Presets
                colors: ['bannerBackground', 'textColor'],
                typography: ['fontSize', 'fontWeight', 'fontFamily', 'letterSpacing'],
                animation: ['animationSpeed'],
                spacing: ['bannerHeight', 'itemSpacing'],
                symbols: ['separatorSymbol'] // dot, circle, square, diamond, star, heart, arrow
            }
        },
        
        // STYLE-PRESET-OPTIONEN für AI-Entscheidung
        aiStylePresets: {
            'flash-sale': 'Urgent Sales mit großem, bold Text - perfekt für zeitkritische Angebote',
            'luxury-spacing': 'Luxus mit Letter Spacing - elegant für Premium-Angebote',
            'business-compact': 'Kompakt & Professional - vertrauenswürdig für B2B',
            'neon-orange': 'Klassisches Neon Orange - auffällig für Tech/Gaming',
            'neon-green': 'Electric Neon Grün - futuristisch für Innovation',
            'romantic-deep-red': 'Tief romantisch & weiblich - sinnlich für Lifestyle',
            'tech-minimal-bw': 'Minimalistisch schwarz-weiß - clean für Tech',
            'chakra-rainbow': 'Spirituell & energetisch - holistische Farben',
            'spring-fresh': 'Frisch für Wellness & Health - natürliche Töne'
        },
        
        industryOptimization: {
            spiritual: { stylePreset: 'chakra-rainbow', separatorSymbol: 'star', bannerHeight: 58 },
            wellness: { stylePreset: 'spring-fresh', separatorSymbol: 'heart', bannerHeight: 50 },
            luxury: { stylePreset: 'luxury-spacing', separatorSymbol: 'diamond', bannerHeight: 62 },
            tech: { stylePreset: 'neon-green', separatorSymbol: 'square', bannerHeight: 48 },
            ecommerce: { stylePreset: 'flash-sale', separatorSymbol: 'arrow', bannerHeight: 55 },
            business: { stylePreset: 'business-compact', separatorSymbol: 'dot', bannerHeight: 45 }
        }
    },

    qaWidget: {
        aiDescription: "Ein interaktives Q&A Widget mit einem Bild links (30%) und expandierbaren Fragen-Antworten rechts (70%). Perfekt für FAQ-Bereiche, Produkterklärungen und Kundensupport. Unterstützt beliebig viele Q&A-Paare mit smooth Animationen und Hover-Effekten.",
        aiDesignTags: ["faq", "questions-answers", "interactive", "expandable", "customer-support", "product-info", "accordion", "help-section", "responsive", "user-friendly"]
    },

    holisticTestimonial: {
        aiDescription: "Ein modernes Testimonials Widget mit 4-Karten-Layout, Sterne-Bewertungen und Trust-Logos. Zeigt Kundenbewertungen in eleganten Karten mit Avatars, Bewertungen und Standorten. Inkludiert eine Trust-Logo-Leiste für zusätzliche Glaubwürdigkeit. Perfekt für Social Proof und Vertrauensaufbau.",
        aiDesignTags: ["testimonials", "social-proof", "reviews", "trust-badges", "customer-feedback", "ratings", "cards-layout", "avatars", "credibility", "conversion-optimization"]
    },


    bragBar: {
        aiDescription: "Eine klassische Brag Bar für Logo-Präsentation mit 'As seen on' oder 'Trusted by' Funktionalität. Zeigt Marken-Logos mittig nebeneinander mit konfigurierbaren Hover-Effekten, Filtern und optionalen Links. Unterstützt responsive Layout und Animationen. Perfekt für Vertrauensaufbau und Social Proof.",
        aiDesignTags: ["brag-bar", "logos", "as-seen-on", "trusted-by", "social-proof", "brands", "media-mentions", "credibility", "press", "marketing"]
    },

    spiritualFeatureBanner: {
        aiDescription: "Ein spirituelles Feature-Banner mit zentralem Bild und 4 Features (2 links, 2 rechts). Perfekt für Yoga-Studios, Wellness-Center und spirituelle Services. Zeigt Features elegant um ein zentrales Hero-Bild arrangiert mit inline Text-Editing und responsive Design.",
        aiDesignTags: ["spiritual", "features", "center-image", "yoga", "wellness", "meditation", "holistic", "balanced-layout", "elegant", "mindfulness"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                'features.0.title': { maxLength: 30, type: 'feature-title', priority: 'high', prompt: 'Kraftvoller Feature-Titel der einen Hauptvorteil beschreibt' },
                'features.0.description': { maxLength: 120, type: 'feature-description', priority: 'high', prompt: 'Detaillierte Beschreibung des Features und seiner Vorteile' },
                'features.1.title': { maxLength: 30, type: 'feature-title', priority: 'high', prompt: 'Kraftvoller Feature-Titel der einen Hauptvorteil beschreibt' },
                'features.1.description': { maxLength: 120, type: 'feature-description', priority: 'high', prompt: 'Detaillierte Beschreibung des Features und seiner Vorteile' },
                'features.2.title': { maxLength: 30, type: 'feature-title', priority: 'high', prompt: 'Kraftvoller Feature-Titel der einen Hauptvorteil beschreibt' },
                'features.2.description': { maxLength: 120, type: 'feature-description', priority: 'high', prompt: 'Detaillierte Beschreibung des Features und seiner Vorteile' },
                'features.3.title': { maxLength: 30, type: 'feature-title', priority: 'high', prompt: 'Kraftvoller Feature-Titel der einen Hauptvorteil beschreibt' },
                'features.3.description': { maxLength: 120, type: 'feature-description', priority: 'high', prompt: 'Detaillierte Beschreibung des Features und seiner Vorteile' }
            },
            
            design: {
                colors: ['backgroundColor', 'featureTitleColor', 'featureDescriptionColor'],
                layout: ['layoutStyle'], // classic-center, image-top-vertical, image-top-horizontal
                typography: ['featureTitleSize', 'featureTitleWeight', 'featureTitleFont', 'featureDescriptionFont'],
                effects: ['enableAnimations', 'animationType', 'animationDuration'],
                spacing: ['padding', 'featureSpacing', 'featureVerticalSpacing'],
                image: ['centerImageWidth', 'centerImageHeight', 'centerImageBorderRadius']
            },
            
            assets: {
                centerImage: { type: 'feature-hero', priority: 'high', fallback: 'spiritual-default' }
            }
        },
        
        aiLayoutOptions: {
            'classic-center': 'Bild zentriert, 2 Features links, 2 Features rechts - ausgewogen und elegant',
            'image-top-vertical': 'Bild oben, alle Features vertikal untereinander - story-telling fokussiert',
            'image-top-horizontal': 'Bild oben, Features in 2x2 Grid - kompakt und strukturiert'
        },
        
        industryOptimization: {
            spiritual: { layoutStyle: 'classic-center', animationType: 'fadeInSlow', featureTitleColor: '#8B7355' },
            wellness: { layoutStyle: 'image-top-vertical', animationType: 'fadeIn', featureTitleColor: '#11998E' },
            coaching: { layoutStyle: 'classic-center', animationType: 'fadeInUp', featureTitleColor: '#667EEA' }
        }
    },

    fancyFooter: {
        aiDescription: "Ein multifunktionaler Premium-Footer mit verschiedenen Layout-Modi und Styles. Kombiniert Logo, Slogan, Kategorien, Adressen, Social Links und Newsletter-Anmeldung. Unterstützt Corporate, Modern, Minimal und Creative Layouts. Perfekt für professionelle Websites, Landing-Pages und Business-Präsenzen mit starker Brand-Integration.",
        aiDesignTags: ["footer", "premium-design", "multi-layout", "corporate", "modern", "minimal", "creative", "brand-integration", "social-links", "newsletter", "contact-info", "navigation", "professional", "responsive"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                'categories.0.title': { maxLength: 20, type: 'nav-category', priority: 'high', prompt: 'Navigation-Kategorie-Titel (z.B. Services, Company, Resources)' },
                'categories.0.links.0.text': { maxLength: 25, type: 'nav-link', priority: 'medium', prompt: 'Navigation-Link-Text' },
                'categories.0.links.1.text': { maxLength: 25, type: 'nav-link', priority: 'medium', prompt: 'Navigation-Link-Text' },
                'categories.1.title': { maxLength: 20, type: 'nav-category', priority: 'high', prompt: 'Navigation-Kategorie-Titel' },
                'contactInfo.address': { maxLength: 60, type: 'address', priority: 'high', prompt: 'Vollständige Geschäftsadresse mit Straße, PLZ und Stadt' },
                'contactInfo.phone': { maxLength: 20, type: 'phone', priority: 'high', prompt: 'Geschäfts-Telefonnummer' },
                'contactInfo.email': { maxLength: 30, type: 'email', priority: 'high', prompt: 'Geschäfts-E-Mail-Adresse' }
            },
            
            design: {
                colors: ['backgroundColor', 'textColor', 'linkColor', 'categoryTitleColor'],
                layout: ['columnLayout'], // 3-column, 4-column, 2-column
                typography: ['fontSize', 'fontWeight', 'categoryTitleFont'],
                social: ['socialIconStyle'], // brand-colors, minimal-dark, light-outline, etc.
                theme: ['logoInvert'] // für Dark/Light Mode
            },
            
            assets: {
                logoImage: { type: 'brand-logo', priority: 'high', fallback: 'none' }
            }
        },
        
        // SOCIAL-ICON-STYLE-OPTIONEN
        aiSocialIconStyles: {
            'brand-colors': 'Original Social Media Farben - vertrauenswürdig und erkennbar',
            'minimal-dark': 'Minimalistisch dunkel - clean und modern',
            'light-outline': 'Helle Outlines - elegant und subtil',
            'dark-outline': 'Dunkle Outlines - professionell und dezent',
            'gradient-modern': 'Moderne Gradienten mit Glow - auffällig und trendy'
        },
        
        industryOptimization: {
            spiritual: { socialIconStyle: 'gradient-modern', logoInvert: false, columnLayout: '3-column' },
            business: { socialIconStyle: 'minimal-dark', logoInvert: true, columnLayout: '4-column' },
            wellness: { socialIconStyle: 'brand-colors', logoInvert: false, columnLayout: '3-column' },
            luxury: { socialIconStyle: 'light-outline', logoInvert: false, columnLayout: '2-column' }
        }
    },

    // ========================================
    // SIMPLISTIC SERVICES WIDGET
    // ========================================
    simplicisticServices: {
        aiDescription: "Ein professionelles Services-Widget zur Präsentation von Dienstleistungen mit Icons, Titeln und Beschreibungen. Unterstützt Icon-Upload und Icon-Picker Integration, verschiedene Grid-Layouts und Hover-Effekte. Ideal für Agenturen, Freelancer, Consultants und Service-Anbieter.",
        aiDesignTags: ["services", "business", "professional", "grid-layout", "icons", "consulting", "agency", "portfolio", "features", "responsive"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                titleText: { maxLength: 50, type: 'headline', priority: 'high', prompt: 'Überschrift für die Services-Sektion (z.B. "Our Services", "What We Offer")' },
                subtitleText: { maxLength: 120, type: 'subtitle', priority: 'medium', prompt: 'Beschreibung der Services-Übersicht und deren Nutzen für Kunden' }
            },
            
            services: {
                name: { maxLength: 30, type: 'service-title', priority: 'high', prompt: 'Prägnanter Service-Name der die Dienstleistung klar beschreibt' },
                description: { maxLength: 150, type: 'service-description', priority: 'high', prompt: 'Detaillierte Beschreibung des Services und seiner Vorteile für den Kunden' }
            },
            
            design: {
                colors: ['titleColor', 'subtitleColor', 'serviceNameColor', 'serviceDescriptionColor', 'serviceIconColor', 'backgroundColor'],
                layout: ['serviceLayout', 'servicesPerRow'], // classic-grid, masonry-flow, luxury-cards, glass-panels
                typography: ['titleSize', 'titleWeight', 'serviceNameSize', 'serviceDescriptionSize'],
                spacing: ['servicePadding', 'serviceSpacing', 'contentSpacing'],
                effects: ['serviceHoverEffect', 'serviceShadow']
            },
            
            assets: {
                serviceIcons: { type: 'icon', priority: 'high', fallback: 'default-business-icons', source: 'picker-or-upload' }
            }
        },
        
        // LAYOUT-OPTIONEN für AI-Entscheidung
        aiLayoutOptions: {
            'classic-grid': 'Klassisches Grid mit Icons oben - professionell und übersichtlich',
            'masonry-flow': 'Organisches Layout mit unterschiedlichen Höhen - modern und dynamisch',
            'luxury-cards': 'Premium-Cards mit goldenen Akzenten - hochwertig und elegant',
            'glass-panels': 'Glasmorphism-Design mit Transparenz - modern und trendy',
            'icon-left': 'Icons links, Text rechts - kompakt und scanbar'
        },
        
        // BRANCHEN-SPEZIFISCHE ANPASSUNGEN
        industryOptimization: {
            spiritual: { serviceLayout: 'glass-panels', servicesPerRow: 2, serviceIconColor: '#9333ea' },
            wellness: { serviceLayout: 'luxury-cards', servicesPerRow: 2, serviceIconColor: '#10b981' },
            business: { serviceLayout: 'classic-grid', servicesPerRow: 3, serviceIconColor: '#3b82f6' },
            consulting: { serviceLayout: 'classic-grid', servicesPerRow: 2, serviceIconColor: '#6366f1' },
            agency: { serviceLayout: 'masonry-flow', servicesPerRow: 3, serviceIconColor: '#f59e0b' },
            tech: { serviceLayout: 'glass-panels', servicesPerRow: 4, serviceIconColor: '#06b6d4' }
        },

        // DEFAULT SERVICES für verschiedene Branchen
        defaultServices: {
            consulting: [
                { name: 'Strategy Consulting', description: 'Strategic business planning and market analysis', icon: 'trophy' },
                { name: 'Process Optimization', description: 'Streamline operations for maximum efficiency', icon: 'diamond' },
                { name: 'Digital Transformation', description: 'Guide your business into the digital age', icon: 'internet' },
                { name: 'Performance Analysis', description: 'Data-driven insights for better decisions', icon: 'reward' }
            ],
            agency: [
                { name: 'Web Development', description: 'Custom websites and web applications', icon: 'internet' },
                { name: 'Digital Marketing', description: 'Online marketing strategies that convert', icon: 'paper-plane' },
                { name: 'Brand Design', description: 'Professional brand identity and design', icon: 'feather' },
                { name: 'SEO Optimization', description: 'Improve your search engine rankings', icon: 'star' }
            ],
            wellness: [
                { name: 'Personal Coaching', description: 'One-on-one guidance for personal growth', icon: 'yoga' },
                { name: 'Group Sessions', description: 'Community-based wellness programs', icon: 'couple' },
                { name: 'Online Courses', description: 'Self-paced learning experiences', icon: 'video' },
                { name: 'Wellness Retreats', description: 'Transformative retreat experiences', icon: 'mountain' }
            ]
        }
    },

    // ========================================
    // BULLET POINTS WIDGET
    // ========================================
    bulletPointsWidget: {
        aiDescription: "Ein vielseitiges Bullet-Points-Widget mit Rich Text Editor, Icon-Integration und Background-Image-Effekten. Perfekt für Benefits, Features, Prozesse und Key-Points mit professioneller Darstellung.",
        aiDesignTags: ["bullet-points", "benefits", "features", "rich-text", "icons", "professional", "content", "highlights", "advantages", "key-points"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                titleText: { maxLength: 50, type: 'headline', priority: 'high', prompt: 'Überschrift für die Bullet-Points-Sektion (z.B. "Key Benefits", "Why Choose Us")' }
            },
            
            bulletPoints: {
                richText: { maxLength: 200, type: 'rich-text', priority: 'high', prompt: 'Rich-Text Bullet-Point mit Formatierung und wichtigen Details' }
            },
            
            design: {
                colors: ['titleColor', 'bulletPointColor', 'bulletIconColor', 'backgroundColor'],
                layout: ['bulletLayout', 'bulletPointsPerRow'], // icon-left, icon-top, numbered, minimal
                typography: ['titleSize', 'titleWeight', 'bulletPointSize'],
                spacing: ['bulletPointSpacing', 'bulletPointPadding', 'contentSpacing'],
                effects: ['backgroundImage', 'imageEffect', 'backgroundImageOpacity']
            },
            
            assets: {
                bulletIcons: { type: 'icon', priority: 'high', fallback: 'default-bullet-icons', source: 'picker-or-upload' },
                backgroundImage: { type: 'background', priority: 'medium', fallback: 'none' }
            }
        },
        
        // LAYOUT-OPTIONEN für AI-Entscheidung
        aiLayoutOptions: {
            'icon-left': 'Icons links, Text rechts - klassisch und scanbar',
            'icon-top': 'Icons oben, Text unten - zentriert und fokussiert',
            'numbered': 'Nummerierte Liste ohne Icons - strukturiert und klar',
            'minimal': 'Minimalistisch ohne Icons - clean und textfokussiert'
        },
        
        // BRANCHEN-SPEZIFISCHE ANPASSUNGEN
        industryOptimization: {
            spiritual: { bulletLayout: 'icon-left', bulletIconColor: '#9333ea', bulletPointsPerRow: 1 },
            wellness: { bulletLayout: 'icon-top', bulletIconColor: '#10b981', bulletPointsPerRow: 2 },
            business: { bulletLayout: 'numbered', bulletIconColor: '#3b82f6', bulletPointsPerRow: 2 },
            consulting: { bulletLayout: 'icon-left', bulletIconColor: '#6366f1', bulletPointsPerRow: 1 },
            agency: { bulletLayout: 'icon-top', bulletIconColor: '#f59e0b', bulletPointsPerRow: 2 },
            tech: { bulletLayout: 'minimal', bulletIconColor: '#06b6d4', bulletPointsPerRow: 2 }
        },

        // DEFAULT BULLET POINTS für verschiedene Branchen
        defaultBulletPoints: {
            business: [
                { richText: '<strong>Increased Revenue</strong> - Drive measurable business growth', icon: 'trophy' },
                { richText: '<strong>Expert Strategy</strong> - Professional guidance and planning', icon: 'star' },
                { richText: '<strong>Proven Results</strong> - Track record of successful outcomes', icon: 'diamond' },
                { richText: '<strong>Ongoing Support</strong> - Continuous assistance and optimization', icon: 'reward' }
            ],
            wellness: [
                { richText: '<strong>Holistic Approach</strong> - Mind, body, and spirit integration', icon: 'yoga' },
                { richText: '<strong>Personal Growth</strong> - Transform your life from within', icon: 'mountain' },
                { richText: '<strong>Community Support</strong> - Connect with like-minded individuals', icon: 'couple' },
                { richText: '<strong>Lasting Change</strong> - Build habits that stick for life', icon: 'star' }
            ],
            consulting: [
                { richText: '<strong>Strategic Planning</strong> - Comprehensive business strategy development', icon: 'diamond' },
                { richText: '<strong>Process Optimization</strong> - Streamline operations for efficiency', icon: 'trophy' },
                { richText: '<strong>Market Analysis</strong> - Deep insights into your industry', icon: 'star' },
                { richText: '<strong>Implementation Support</strong> - Hands-on guidance throughout', icon: 'reward' }
            ]
        }
    },

    // ========================================
    // COMPARISON WIDGET
    // ========================================
    comparisonWidget: {
        aiDescription: "Ein visuelles Before/After Vergleichs-Widget mit Rich Text Editor und übereinander gelappten Bildern. Perfekt für Transformationen, Fortschritte, Vorher/Nachher-Vergleiche und Success Stories.",
        aiDesignTags: ["comparison", "before-after", "transformation", "progress", "success-story", "rich-text", "visual-proof", "testimonial", "results", "journey"],
        
        // AI-EDITIERBARE FELDER
        aiEditableFields: {
            texts: {
                titleText: { maxLength: 60, type: 'headline', priority: 'high', prompt: 'Überschrift für den Vergleich (z.B. "Your Transformation Journey", "Before & After Results")' },
                richTextContent: { maxLength: 500, type: 'rich-text', priority: 'high', prompt: 'Ausführlicher Rich-Text der die Transformation oder den Vergleich beschreibt' }
            },
            
            imageLabels: {
                beforeLabel: { maxLength: 20, type: 'label', priority: 'medium', prompt: 'Label für das Vorher-Bild (z.B. "Before", "Vorher")' },
                afterLabel: { maxLength: 20, type: 'label', priority: 'medium', prompt: 'Label für das Nachher-Bild (z.B. "After", "Nachher")' },
                beforeDate: { maxLength: 30, type: 'date-label', priority: 'medium', prompt: 'Datum für das Vorher-Bild (z.B. "Januar 2023")' },
                afterDate: { maxLength: 30, type: 'date-label', priority: 'medium', prompt: 'Datum für das Nachher-Bild (z.B. "September 2024")' }
            },
            
            design: {
                colors: ['titleColor', 'richTextColor', 'imageLabelColor', 'backgroundColor'],
                layout: ['comparisonLayout', 'textAlignment', 'imageAlignment'],
                typography: ['titleSize', 'titleWeight', 'richTextSize'],
                spacing: ['contentSpacing', 'imageSpacing', 'imageOverlap'],
                images: ['imageWidth', 'imageHeight', 'imageBorderRadius', 'imageShadow']
            },
            
            assets: {
                beforeImage: { type: 'comparison-before', priority: 'high', fallback: 'default-before' },
                afterImage: { type: 'comparison-after', priority: 'high', fallback: 'default-after' }
            }
        },
        
        // LAYOUT-OPTIONEN für AI-Entscheidung
        aiLayoutOptions: {
            'text-left-images-right': 'Text links, Bilder rechts - klassisches Before/After Layout',
            'text-right-images-left': 'Bilder links, Text rechts - visuell fokussiert',
            'text-top-images-bottom': 'Text oben, Bilder unten - vertikal strukturiert'
        },
        
        // BRANCHEN-SPEZIFISCHE ANPASSUNGEN
        industryOptimization: {
            spiritual: { comparisonLayout: 'text-left-images-right', textAlignment: 'left', imageOverlap: 50 },
            wellness: { comparisonLayout: 'text-left-images-right', textAlignment: 'left', imageOverlap: 40 },
            business: { comparisonLayout: 'text-right-images-left', textAlignment: 'left', imageOverlap: 30 },
            consulting: { comparisonLayout: 'text-left-images-right', textAlignment: 'left', imageOverlap: 35 },
            agency: { comparisonLayout: 'text-top-images-bottom', textAlignment: 'center', imageOverlap: 45 },
            fitness: { comparisonLayout: 'text-left-images-right', textAlignment: 'left', imageOverlap: 60 }
        },

        // DEFAULT CONTENT für verschiedene Branchen
        defaultContent: {
            spiritual: {
                title: 'Your Spiritual Transformation',
                richText: 'Discover the profound changes that await you on your spiritual journey. From feeling disconnected to finding your true purpose and inner peace.',
                beforeLabel: 'Before', afterLabel: 'After',
                beforeDate: 'Start of Journey', afterDate: 'Today'
            },
            wellness: {
                title: 'Your Wellness Journey',
                richText: 'Experience the incredible transformation that comes with prioritizing your health and wellbeing. See the difference holistic wellness can make.',
                beforeLabel: 'Before', afterLabel: 'After', 
                beforeDate: 'Day 1', afterDate: '90 Days Later'
            },
            business: {
                title: 'Business Growth Results',
                richText: 'See the measurable impact of our strategic approach. From struggling with growth to achieving consistent, scalable success.',
                beforeLabel: 'Before', afterLabel: 'After',
                beforeDate: 'Initial State', afterDate: '6 Months Later'
            }
        }
    }

};
